let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hmJtw")).then(() => parcelRequire('jb8ZN'));